import moment from 'moment';

/** @return {{ dateStartDefault: moment.Moment, dateEndDefault: moment.Moment }} */
export const getDefaultDatesRange = () => {
  const dateStartDefault = moment().isoWeekday(8);
  const dateEndDefault = moment().isoWeekday(8).add(7, 'days');
  return { dateStartDefault, dateEndDefault };
};
